export default {
    title: 'SMS Conversation',
    notAuthorized: 'You do not have access to send SMS to this lead.',
    emptyBodyTooltip: 'The body of the sms cannot be empty',

    smsBulk: {
        title: 'Compose a new SMS message',
        recipientsLabel: 'Recipient',
        recipients: '{count} selected recipient | {count} selected recipients',
        sender: {
            label: 'Sender',
            backupLabel: 'Sender fallback',
            myself: 'Myself',
            relativeFields: 'Lead-related fields',
            specificUser: 'Specific user',
        },
        template: {
            category: 'Category',
            templateLabel: 'Template',
        },
        localePreference: {
            label: 'Send language',
            fr: 'French',
            en: 'English',
            leadLocale: 'Lead language',
        },
        body: {
            bodyTitle: 'SMS content',
            attributesTitle: 'Attributes',
            attributeSearchPlaceholder: 'Search attributes',
            attributeSearchEmpty: 'No matching attributes.',
            placeholder: 'Type your SMS here...',
            attributePicker: 'Insert attribute',
            loadingTemplate: 'Loading template...',
            previewTitle: 'Preview',
            optOutFooterMention: 'Automatically added when sent',
            characterCount: '{count} / {max}',
            tabs: {
                fr: {
                    label: 'French',
                    subLabel: 'Français',
                },
                en: {
                    label: 'English',
                    subLabel: 'English',
                },
            },
            warnWithTags:
                'Some personalized values may be longer than the preview and exceed the limit.',
            warnWithoutTags: 'The message is close to the maximum length.',
            tooLong: 'Message is too long.',
        },
        footer: {
            cancel: 'Cancel',
            send: 'Send',
            review: 'Review campaign',
        },
        notifications: {
            sendQueued: 'Your SMS messages are being sent.',
            sendFailed: 'The mass SMS could not be sent. Please try again.',
        },
        validation: {
            noSender: 'Please select a sender.',
            noSenderBackup: 'Please select a fallback sender.',
            noRecipients: 'No recipients selected.',
            emptyBody: 'Body is empty.',
            bodyTooLong: 'Body exceeds the {max}-character limit.',
            missingLocaleTitle: 'Missing locale content',
            missingLocaleMessage:
                'The {locale} body is empty. Leads in this locale will receive the other locale body. Continue?',
            missingLocaleConfirm: 'Send anyway',
        },
    },
};
